declare const __PUBLIC_ANALYTICS_ENABLED__: string;
declare const __PUBLIC_POSTHOG_KEY__: string;
declare const __PUBLIC_POSTHOG_INGEST_HOST__: string;
declare const __PUBLIC_POSTHOG_UI_HOST__: string;
declare const __PUBLIC_POSTHOG_CROSS_SUBDOMAIN__: string;

export const adminAnalyticsEnv = {
  enabled: __PUBLIC_ANALYTICS_ENABLED__ === "true",
  apiKey: __PUBLIC_POSTHOG_KEY__,
  ingestHost: __PUBLIC_POSTHOG_INGEST_HOST__,
  uiHost: __PUBLIC_POSTHOG_UI_HOST__,
  crossSubdomainCookie: __PUBLIC_POSTHOG_CROSS_SUBDOMAIN__ === "true"
} as const;
